import styled from "styled-components";
import { media } from "../../globalStyles";

export const NavContainer = styled.nav`
  width: 100%;
  height: 80px;
  background-color: #0f1923ff;
  color: rgb(97, 78, 32);
  border-bottom: 5px solid black;
  display: flex;
  justify-content: center;
`;

export const NavWrapper = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0px;
`;

export const IconBlock = styled.div`
display:none;
${media.mobile}{
  display: block;
}

`

export const NavLogo = styled.div`
  img {
    height: 48px;
    object-fit: cover;
  }
  ${media.mobile} {
    img {
      height: 35px;
      object-fit: cover;
    }
  }
`;


export const ProfileContainer = styled.div`
display:flex;
flex-direction: column;
position:relative;

`

export const ProfileText = styled.div`
display:flex;
align-items: center;
justify-content: space-between;
cursor: pointer;
width:100%;

color:whiteSmoke;
transition: all 0.5s ease;
&:hover{
  color: #614e20ff;
}

h3{
  font-weight: 400;
}
${media.mobile}{
  display: none;
}
`

export const SubMenu = styled.div`
position: absolute;
width: 180px;
top: 36px;
background-color: white;
${media.mobile}{
  right: 5px;
}
`

export const MobileHeading = styled.h3`
padding:6px 10px;
width: 100%;
margin-bottom: 2px;
font-size: 15px;
border-bottom: 1px solid grey;
color:whitesmoke;
font-weight:300;
display:none;
background-color: #614e20ff;
${media.mobile}{
 display:block;
}
`

export const MenuItems = styled.div`

padding: 8px;
font-size: 14px;
border-bottom: 1px solid grey;
color:grey;
cursor: pointer;

&:hover{
  background-color: rgb(231, 231, 231);
}

span{
  margin-left: 3px;
}


`